<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect},
    data() {
        return {
            title: "Colegios",
            items: [
                {
                text: "Configuración",
                href: "/"
                },
                {
                text: "Colegios",
                active: true
                }
            ],
            colegioseleccionada: null,
            datoscolegios: [],
            todosColegios: [],
            busquedaColegio: '',
            dropdownColegioAbierto: false,
            isLoading: false,                      //colegio seleccionada en el buscador
            colegioid_seleccion: '',                       //id colegio
            colegioid_editar: {},                       //id colegio
            habilitar_boton: false,
            editing: false,
            eventos: [], // Eventos asociados
            evaluacionesActividad: [],
            comentariosColegio: [],
            busquedaComentario: '',
            reenviandoComentarios: {},
            comentarioNuevo: '',
            guardandoComentario: false,
            ColegioNoExiste: false, // Eventos asociados,
            originalcolegio:'',
            CRMisButtonDisabled:false,
            isLoading:false,
            opciones:['Si','No'],
            estados:[],
            phoneerror1:'',
            phoneerror2:'',
            phoneerror3:'',
            emailError1:'',
            emailError2:'',
            estado:{}
        };
    },
    computed:{
        isEmailValid1() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.colegioid_editar.correo_colegio);
        },
        isEmailValid2() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.colegioid_editar.correo_colegio_2);
        },
        comentarioCharsRestantes() {
            const max = 2000;
            const actual = (this.comentarioNuevo || '').length;
            return max - actual;
        },
        colegiosVisiblesEnBusqueda() {
            const resultados = Array.isArray(this.colegiosFiltrados) ? this.colegiosFiltrados : [];
            return resultados.slice(0, 80);
        },
        colegiosFiltrados() {
            const query = (this.busquedaColegio || '').trim().toLowerCase();
            const source = Array.isArray(this.todosColegios) ? this.todosColegios : [];

            if (!query) {
                return source;
            }

            return source.filter((colegio) => {
                return [
                    colegio.rbd,
                    colegio.nombre,
                    colegio.segmentacion,
                    colegio.comuna,
                    colegio.region,
                    colegio.propietario,
                    colegio.nombre_director,
                    colegio.nombre_orientador,
                ].join(' ').toLowerCase().includes(query);
            });
        },
        comentariosFiltrados() {
            const query = (this.busquedaComentario || '').trim().toLowerCase();
            const source = Array.isArray(this.comentariosColegio) ? this.comentariosColegio : [];

            if (!query) {
                return source;
            }

            return source.filter((comentario) => {
                const texto = [
                    comentario.comentario,
                    comentario.usuario_nombre,
                    comentario.sync_mensaje,
                    comentario.sync_respuesta,
                    comentario.sync_estado,
                ].join(' ').toLowerCase();

                return texto.includes(query);
            });
        }
    },
    methods:{
        formatearNombreEvento(evento) {
            const base = (evento?.nombre_difusion || '').toString().trim();
            const comentario = (evento?.comentario_nombre_evento || '').toString().trim();
            if (!base) return comentario || '-';
            return comentario ? `${base} (${comentario})` : base;
        },
        validacion() {
            const campos = {
                //nombre_director: 'Nombre Director',
                //correo_colegio: 'Correo Director',
                //telefono_director: 'Teléfono Director',
                //telefono_colegio: 'Teléfono',
                //nombre_orientador: 'Nombre Orientador',
                //correo_colegio_2: 'Correo Orientador',
                //telefono_orientador: 'Teléfono Orientador',
                colegio_visitado: '¿Colegio Visitado?',
            };
            for (let campo in campos) {
                if (!this.colegioid_editar[campo]) {
                    this.msgval(campos[campo]);
                    return false;
                }
            }
            if (!this.estado || !this.estado.codigo) {
                this.msgval('Estado');
                return false;
            }
            return true;//this.crear_evento();
        },
        validateEmail1() {
            if (this.colegioid_editar.correo_colegio && !this.isEmailValid1) {
                this.emailError1 = 'El correo electrónico no es válido.';
            } else {
                this.emailError1 = '';
            }
        },
        validateEmail2() {
            if (this.colegioid_editar.correo_colegio_2 && !this.isEmailValid2) {
                this.emailError2 = 'El correo electrónico no es válido.';
            } else {
                this.emailError2 = '';
            }
        },
        modificar_id(colegioseleccionada) {
            const colegio = colegioseleccionada;
            if (colegio) {
                this.colegioid_seleccion = colegio;
                this.originalcolegio = colegio;
                this.habilitar_boton = true;
            } else {
                this.habilitar_boton = false;
            }
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        toggleEdit() {
            this.originalcolegio = { ...this.colegioid_seleccion };
            if (this.editing) {
                //console.log('editar')
                if(this.validacion()){
                    this.isLoading=true
                    this.colegioid_editar.estado_id = this.estado && this.estado.codigo ? this.estado.codigo : this.colegioid_editar.estado_colegio;
                    axios.post('/api/editar_colegio',this.colegioid_editar).then(res=>{
                        if(res.data.estado){
                            //this.sucursal=res.data.sucursal
                            this.msg(res.data.color,res.data.mensaje);
                            this.colegioid_seleccion = {
                                ...this.colegioid_seleccion,
                                ...res.data.colegio,
                            };
                            this.colegioid_editar = { ...this.colegioid_seleccion };
                            //console.log(res.data.mensaje)
                            this.isLoading=false
                            // Evita sobreescribir inmediatamente con datos antiguos del CRM.
                            // La sincronización CRM se mantiene disponible de forma manual.
                            //window.location.reload();
                        }else{
                            this.msg(res.data.color,res.data.mensaje);
                            //console.log(res.data.mensaje)
                            this.isLoading=false
                        }
                    })
                }
            }
            this.editing = !this.editing;
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        consultarColegio() {
            //console.log('consultarColegio');
            const rbd = this.colegioseleccionada.rbd; // RBD del colegio seleccionado
            //console.log(rbd);
            axios.get(`/api/get_colegio/${rbd}`).then(response => {
                if(response.data.estado){
                    this.colegioid_seleccion = response.data.colegio;
                    this.eventos = response.data.colegio.eventos;
                    this.evaluacionesActividad = response.data.colegio.evaluaciones_actividad || [];
                    this.comentariosColegio = response.data.colegio.comentarios || [];
                    this.comentarioNuevo = '';
                    //console.log(this.colegioid_seleccion)
                    this.colegioid_editar=this.colegioid_seleccion;
                    this.colegioid_editar.id=this.colegioid_seleccion.id;
                    this.colegioid_editar.rbd=this.colegioid_seleccion.rbd;
                    this.colegioid_editar.direccion=this.colegioid_seleccion.direccion;
                    this.colegioid_editar.comuna=this.colegioid_seleccion.comuna;
                    this.colegioid_editar.provincia=this.colegioid_seleccion.provincia;
                    this.colegioid_editar.region=this.colegioid_seleccion.region;
                    this.colegioid_editar.telefono_colegio=this.colegioid_seleccion.telefono;
                    this.colegioid_editar.colegio_visitado=this.colegioid_seleccion.colegio_visitado;
                    this.estado=this.estados.filter(est=>est.codigo==this.colegioid_seleccion.estado_colegio)[0];
                    this.colegioid_editar.nombre_orientador=this.colegioid_seleccion.nombre_orientador;
                    this.colegioid_editar.correo_colegio_2=this.colegioid_seleccion.correo_colegio_2;
                    this.colegioid_editar.telefono_orientador=this.colegioid_seleccion.telefono_orientador;
                    this.colegioid_editar.nombre_director=this.colegioid_seleccion.nombre_director;
                    this.colegioid_editar.correo_colegio=this.colegioid_seleccion.correo_colegio;
                    this.colegioid_editar.telefono_director=this.colegioid_seleccion.telefono_director;
                    if (this.colegioid_seleccion.estado_colegio!=null) {
                        //this.colegioid_editar.estado=this.estados.find(est=>est.codigo==this.colegioid_seleccion.estado_colegio)
                    }
                    this.actualizarDesdeAPIExterna();
                    /*Swal.fire({
                        icon: "success",
                        title: "Buscando Colegio..",
                        text: "La información del colegio se ha actualizado correctamente.",
                        timer: 3000,
                        showConfirmButton: false
                    });*/
                }else{
                    // console.log('Error al consultar')
                    console.log("No existen datos del colegio: "+rbd);
                    this.colegioid_seleccion = false;
                    this.eventos = '';
                    this.evaluacionesActividad = [];
                    this.comentariosColegio = [];
                    this.comentarioNuevo = '';
                    this.ColegioNoExiste=true;
                }
            });
        },
        handleKeydown(event) {
            // Verifica si la tecla presionada es Enter o Enter del teclado numérico
            if (event.key == "Enter" || event.code == "Enter" || event.keyCode == 13) {
                event.preventDefault(); // Previene comportamientos predeterminados (como un submit en formularios)
                //this.consultarColegio();
            }
        },
        actualizarDesdeAPIExterna() {
            //console.log('actualizarDesdeAPIExterna');
            const rbd = this.colegioseleccionada.rbd;
            this.isLoading=true;
            this.CRMisButtonDisabled=true;
            axios.get(`/api/get_colegio_crm/${rbd}`).then(response => {
                if(response.data.estado){
                    this.colegioid_seleccion = response.data.colegio;
                    this.eventos = response.data.colegio.eventos;
                    this.evaluacionesActividad = response.data.colegio.evaluaciones_actividad || [];
                    this.comentariosColegio = response.data.colegio.comentarios || [];
                    Swal.fire({
                        icon: "success",
                        title: "Datos actualizados",
                        text: "La información del colegio se ha actualizado correctamente.",
                        timer: 3000,
                        showConfirmButton: false
                    });
                    this.isLoading=false
                    this.CRMisButtonDisabled=false
                }else{
                    console.log("Error al actualizar desde la API externa:");
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "No se pudo actualizar la información del colegio.",
                        timer: 3000,
                        showConfirmButton: false
                    });
                    this.isLoading=false
                    this.CRMisButtonDisabled=false
                }
            })
        },
        formatFecha(fecha) {
            if (!fecha) return "-";
            const opciones = { year: "numeric", month: "2-digit", day: "2-digit" };
            return new Date(fecha).toLocaleDateString("es-ES", opciones);
        },
        formatFechaHora(fecha) {
            if (!fecha) return "-";
            const opciones = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" };
            return new Date(fecha).toLocaleString("es-ES", opciones);
        },
        formatearCalificacion(calificacion) {
            if (!calificacion) return '-';
            const texto = String(calificacion);
            const match = texto.match(/(\d)\/7/);
            return match ? `${match[1]}/7` : texto;
        },
        estadoSyncLabel(comentario) {
            if (!comentario) return 'Pendiente';
            if (comentario.sync_ok === true || comentario.sync_ok === 1) return 'OK';
            if (comentario.sync_estado === 'error') return 'Error';
            if (comentario.sync_estado === 'pendiente') return 'Pendiente';
            return comentario.sync_estado || 'Pendiente';
        },
        estadoSyncBadgeClass(comentario) {
            if (!comentario) return 'badge-secondary';
            if (comentario.sync_ok === true || comentario.sync_ok === 1) return 'badge-success';
            if (comentario.sync_estado === 'error') return 'badge-danger';
            return 'badge-warning';
        },
        respuestaSyncTexto(comentario) {
            if (!comentario) return '-';
            if (comentario.sync_respuesta && String(comentario.sync_respuesta).trim() !== '') {
                return comentario.sync_respuesta;
            }
            if (comentario.sync_mensaje && String(comentario.sync_mensaje).trim() !== '') {
                return comentario.sync_mensaje;
            }
            return '-';
        },
        reenviarComentarioColegio(comentario) {
            if (!comentario || !comentario.id) {
                return;
            }

            this.$set(this.reenviandoComentarios, comentario.id, true);
            axios.post('/api/reenviar_comentario_colegio', {
                comentario_id: comentario.id,
            }).then((response) => {
                if (response.data && response.data.estado) {
                    this.comentariosColegio = response.data.comentarios || [];
                    const sincronizado = !!response.data.sincronizado;
                    const mensajeBase = response.data.mensaje || 'Reenvío procesado';
                    const mensajeSync = response.data.mensaje_sincronizacion ? ` (${response.data.mensaje_sincronizacion})` : '';
                    this.msg(sincronizado ? 'success' : 'warning', `${mensajeBase}${mensajeSync}`);
                    return;
                }

                this.msg('error', (response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudo reenviar el comentario');
            }).catch((error) => {
                const mensaje = error?.response?.data?.mensaje || 'No se pudo reenviar el comentario';
                this.msg('error', mensaje);
            }).finally(() => {
                this.$set(this.reenviandoComentarios, comentario.id, false);
            });
        },
        guardarComentarioColegio() {
            if (!this.colegioid_seleccion || !this.colegioid_seleccion.id) {
                this.msg('warning', 'Debes seleccionar un colegio');
                return;
            }

            const comentario = (this.comentarioNuevo || '').trim();
            if (!comentario) {
                this.msg('warning', 'El comentario no puede estar vacío');
                return;
            }

            if (comentario.length > 2000) {
                this.msg('warning', 'El comentario no puede superar 2000 caracteres');
                return;
            }

            this.guardandoComentario = true;
            axios.post('/api/guardar_comentario_colegio', {
                colegio_id: this.colegioid_seleccion.id,
                comentario,
            }).then((response) => {
                if (response.data && response.data.estado) {
                    this.comentariosColegio = response.data.comentarios || [];
                    this.comentarioNuevo = '';
                    const sincronizado = !!response.data.sincronizado;
                    const mensajeBase = response.data.mensaje || 'Comentario guardado';
                    const mensajeSync = response.data.mensaje_sincronizacion ? ` (${response.data.mensaje_sincronizacion})` : '';
                    this.msg(sincronizado ? 'success' : 'warning', `${mensajeBase}${mensajeSync}`);
                    return;
                }

                this.msg('error', (response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudo guardar el comentario');
            }).catch((error) => {
                const mensaje = error?.response?.data?.mensaje || 'No se pudo guardar el comentario';
                this.msg('error', mensaje);
            }).finally(() => {
                this.guardandoComentario = false;
            });
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento.codigo);
            window.location.href = "/web/configuracion/eventos";
        },
        crear_evento(){
            const colegioOrigen = (this.colegioseleccionada && this.colegioseleccionada.rbd)
                ? this.colegioseleccionada
                : this.colegioid_seleccion;

            if (!colegioOrigen || !colegioOrigen.rbd) {
                this.msg('error', 'Debes seleccionar un colegio válido.');
                return;
            }
            const rbdSeleccionado = String(colegioOrigen.rbd).trim();
            localStorage.setItem('colegio', JSON.stringify(colegioOrigen));
            localStorage.setItem('colegio_rbd', rbdSeleccionado);
            window.location.href = `/web/configuracion/crearevento?rbd=${encodeURIComponent(rbdSeleccionado)}`;
        },
        customLabel(colegio) {
            const nombre = colegio && colegio.nombre ? colegio.nombre : 'Sin nombre';
            const rbd = colegio && colegio.rbd ? colegio.rbd : 'Sin RBD';
            const comuna = colegio && colegio.comuna ? colegio.comuna : 'Sin comuna';
            const segmentacion = colegio && colegio.segmentacion ? colegio.segmentacion : 'Sin segmentación';
            return `${rbd} - ${nombre} - ${comuna} - ${segmentacion}`;
        },
        customEstado(estado) {
            return `${estado.nombre}`;
        },
        valorColegio(valor) {
            if (valor === null || valor === undefined || String(valor).trim() === '') {
                return '-';
            }

            return valor;
        },
        estadoColegioLabel(codigo) {
            const estado = this.estados.find((item) => String(item.codigo) === String(codigo));
            return estado ? estado.nombre : '-';
        },
        fetchColegios(query) {
            this.busquedaColegio = query || '';
        },
        seleccionarColegio(colegio) {
            if (!colegio || !colegio.rbd) {
                return;
            }

            this.colegioseleccionada = colegio;
            this.dropdownColegioAbierto = false;
            this.consultarColegio();
        },
        buscarColegio() {
            if (this.colegioseleccionada && this.colegioseleccionada.rbd) {
                this.consultarColegio();
                return;
            }

            const primerResultado = this.colegiosVisiblesEnBusqueda[0];
            if (primerResultado) {
                this.colegioseleccionada = primerResultado;
                this.consultarColegio();
                return;
            }

            this.msg('warning', 'No se encontró un colegio con esa búsqueda');
        },
        formatPhoneNumber1() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_director.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_director = "+" + digits;
        },
        validatePhoneNumber1() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_director.length !== 12) {
                this.phoneerror1 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror1 = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        formatPhoneNumber2() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_colegio.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_colegio = "+" + digits;
        },
        validatePhoneNumber2() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_colegio.length !== 12) {
                this.phoneerror2 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror2 = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        formatPhoneNumber3() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_orientador.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_orientador = "+" + digits;
        },
        validatePhoneNumber3() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_orientador.length !== 12) {
                this.phoneerror3 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror3 = "";
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);

            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        }
    },
    mounted(){
        axios.get(`/api/get_estado_colegios`).then(response => {
            this.estados = response.data.estados;
        });
        if (localStorage.getItem("colegio")) {
            const colegio = localStorage.getItem("colegio");
            try {
                this.colegioseleccionada = JSON.parse(colegio);
            } catch (error) {
                this.colegioseleccionada = null;
            }
            localStorage.removeItem("colegio");
            if (this.colegioseleccionada) {
                this.consultarColegio();
            }
        }

    },
    created() {
        this.isLoading=true
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.todosColegios = response.data.colegios.filter((colegio)=> colegio.valido==1);
                this.datoscolegios = this.todosColegios;
                if (localStorage.getItem("rbd_colegio")) {
                    const rbd_colegio = localStorage.getItem("rbd_colegio");
                    localStorage.removeItem("rbd_colegio");
                    this.colegioseleccionada=this.todosColegios.find(colegio=>colegio.rbd==rbd_colegio)
                    this.consultarColegio();
                    this.actualizarDesdeAPIExterna();
                }
            }
        }
        ).catch(error => console.error(error)
        ).finally(() => this.isLoading = false);
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card card-buscador-colegios">
                    <div class="card-body card-buscador-colegios-body">
                        <div class="row row-buscador-colegios">

                            <div class="col-lg-10 col-xl-8 mx-auto contenedor-buscador-colegios">
                                <label for="title">Buscar Colegio</label>
                                <p>Busca por RBD, nombre, comuna, segmentación, director u orientador.</p>
                                <div class="row">
                                    <div class="col-md-10">
                                        <multiselect
                                            class="multiselect-buscador-colegios"
                                            v-model="colegioseleccionada"
                                            :options="colegiosFiltrados"
                                            :searchable="true"
                                            :internal-search="false"
                                            :loading="isLoading"
                                            :custom-label="customLabel"
                                            track-by="rbd"
                                            placeholder="Buscar colegio..."
                                            @search-change="fetchColegios"
                                            @select="seleccionarColegio"
                                            @open="dropdownColegioAbierto = true"
                                            @close="dropdownColegioAbierto = false"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                        >
                                            <template #singleLabel="{ option }">
                                                <span>{{ option.rbd }} - {{ option.nombre }}</span>
                                            </template>
                                            <template #option="{ option }">
                                                <div>
                                                    <div><strong>{{ option.rbd }}</strong> - {{ option.nombre }}</div>
                                                    <small class="text-muted">{{ option.comuna || 'Sin comuna' }} | {{ option.segmentacion || 'Sin segmentación' }} | {{ option.propietario || 'Sin propietario' }}</small>
                                                </div>
                                            </template>
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="col-md-2">
                                    <b-button variant="primary" block @click="buscarColegio" :disabled="!colegioseleccionada && !busquedaColegio.trim()">Buscar</b-button>
                                    </div>
                                </div>
                                <small class="text-muted d-block mt-2">
                                    {{ colegiosFiltrados.length }} resultados disponibles
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="dropdownColegioAbierto">
                <div class="card card-espaciador-buscador-colegios">
                    <div class="card-body"></div>
                </div>
            </div>
            <div class="col-12" v-if="colegioseleccionada">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12" v-if="colegioid_seleccion">
                                <div class="card mt-3 shadow-sm border-light colegio-detail-card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h1 v-if="editing" class="text-primary mb-4">{{ colegioid_seleccion.nombre }}</h1>
                                                <div v-else class="colegio-detail-hero">
                                                    <div class="colegio-detail-hero-bar">
                                                        <div class="colegio-detail-hero-bar__left">
                                                            <div class="colegio-detail-hero-bar__title-row">
                                                                <i class="bx bx-building-house colegio-detail-hero-bar__icon"></i>
                                                                <h1 class="colegio-detail-hero-bar__title">{{ colegioid_seleccion.nombre }}</h1>
                                                            </div>
                                                            <div class="colegio-detail-hero-bar__meta">
                                                                <span class="colegio-detail-chip">RBD {{ valorColegio(colegioid_seleccion.rbd) }}</span>
                                                                <span>{{ valorColegio(colegioid_seleccion.comuna) }}</span>
                                                                <span>{{ valorColegio(colegioid_seleccion.segmentacion) }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="colegio-detail-hero-bar__actions">
                                                            <b-button class="colegio-detail-action-btn colegio-detail-action-btn--white" @click="crear_evento">
                                                                <i class="bx bx-calendar-plus"></i> Crear Evento
                                                            </b-button>
                                                            <b-button class="colegio-detail-action-btn colegio-detail-action-btn--white" @click="toggleEdit">
                                                                <i class="fas fa-edit"></i> Editar
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                    <div class="colegio-detail-update">
                                                        <i class="bx bx-refresh mr-1"></i>
                                                        Última actualización con CRM:
                                                        <strong>{{ colegioid_seleccion.updated_at ? new Date(colegioid_seleccion.updated_at).toLocaleString() : '-' }}</strong>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="editing">
                                                    <div class="col-md-6">
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="rbd"> Nombre Director:</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="direccion" v-model="colegioid_editar.nombre_director" class="form-control border-primary" @keydown="restrictInput_withspace">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Correo Director:</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="ciudad" v-model="colegioid_editar.correo_colegio" class="form-control border-primary" @blur="validateEmail1">
                                                                <p v-if="emailError1" class="error text-primary">{{ emailError1 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Telefono Director:</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="documento" v-model="colegioid_editar.telefono_director" class="form-control border-primary" @input="formatPhoneNumber1" @blur="validatePhoneNumber1" @keydown="restrictToNumbers" maxlength="12">
                                                                <p v-if="phoneerror1" class="error text-primary">{{ phoneerror1 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="rbd"> Teléfono Colegio:</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="name" v-model="colegioid_editar.telefono_colegio" class="form-control border-primary" @input="formatPhoneNumber2" @blur="validatePhoneNumber2" @keydown="restrictToNumbers" maxlength="12">
                                                                <p v-if="phoneerror2" class="error text-primary">{{ phoneerror2 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Nombre Orientador:</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="telefono" v-model="colegioid_editar.nombre_orientador" class="form-control border-primary" @keydown="restrictInput_withspace">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Correo Orientador:</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="colegioid_editar.correo_colegio_2" class="form-control border-primary" @blur="validateEmail2">
                                                                <p v-if="emailError2" class="error text-primary">{{ emailError2 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Telefono Orientador:</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="telefono" v-model="colegioid_editar.telefono_orientador" class="form-control border-primary" @input="formatPhoneNumber3" @blur="validatePhoneNumber3" @keydown="restrictToNumbers" maxlength="12">
                                                                <p v-if="phoneerror3" class="error text-primary">{{ phoneerror3 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> ¿Colegio visitado?:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="colegioid_editar.colegio_visitado"
                                                                    :options="opciones"
                                                                    placeholder="Seleccionar curso"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label> Estado:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="estado"
                                                                    :options="estados"
                                                                    placeholder="Seleccionar estado"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="customEstado"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="rbd"> RBD:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <!-- <label for="pais" class="text-primary"> * Campo Obligatorio</label> -->
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="pais" v-model="colegioid_editar.rbd" disabled class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Dirección:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.direccion" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Comuna:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.comuna" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Provincia:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.provincia" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Región:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.region" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Tipo Educación:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.tipo_educacion" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Nivel Socioeconómico:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.nivel_socioeconomico" class="form-control border-primary">
                                                        </div>
                                                    </div>
                                                    <div class="offset-md-9 col-md-3 mb-3">
                                                        <div class="mt-3 float-right">
                                                            <button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </button>
                                                            <button @click="toggleEdit" class="btn btn-primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar' }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row colegio-detail-readonly" v-else>
                                                    <div class="col-md-6 colegio-detail-column">
                                                        <div class="colegio-detail-panel">
                                                            <div class="colegio-detail-panel__title">Datos del Colegio</div>
                                                            <div class="colegio-detail-table">
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">RBD</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.rbd) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Dirección</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.direccion) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Comuna</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.comuna) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Provincia</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.provincia) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Región</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.region) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Estado Colegio</div>
                                                                    <div class="colegio-detail-table__value">{{ estadoColegioLabel(colegioid_seleccion.estado_colegio) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Segmentación</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.segmentacion) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">¿Colegio visitado?</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.colegio_visitado) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Teléfono Colegio</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.telefono_colegio) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Sede asociada</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.sede_asociada) }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 colegio-detail-column">
                                                        <div class="colegio-detail-panel">
                                                            <div class="colegio-detail-panel__title">Contactos y responsables</div>
                                                            <div class="colegio-detail-table">
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Propietario</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.propietario) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Nombre Director</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.nombre_director) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Correo Director</div>
                                                                    <div class="colegio-detail-table__value colegio-detail-table__value--wrap">{{ valorColegio(colegioid_seleccion.correo_colegio) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Teléfono Director</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.telefono_director) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Nombre Orientador</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.nombre_orientador) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Correo Orientador</div>
                                                                    <div class="colegio-detail-table__value colegio-detail-table__value--wrap">{{ valorColegio(colegioid_seleccion.correo_colegio_2) }}</div>
                                                                </div>
                                                                <div class="colegio-detail-table__row">
                                                                    <div class="colegio-detail-table__label">Teléfono Orientador</div>
                                                                    <div class="colegio-detail-table__value">{{ valorColegio(colegioid_seleccion.telefono_orientador) }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="colegio-detail-tabs-wrap">
                                                        <b-tabs content-class="mt-3" class="colegio-detail-tabs">
                                                            <b-tab title="Eventos asociados" active>
                                                                <div v-if="eventos.length > 0">
                                                                    <div class="table-responsive">
                                                                        <table class="table table-bordered">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>N Digitalizados</th>
                                                                                    <th>N Asistentes</th>
                                                                                    <th>Total</th>
                                                                                    <th>Código</th>
                                                                                    <th>Nombre Difusión</th>
                                                                                    <th>Estado</th>
                                                                                    <th>Fecha Inicio</th>
                                                                                    <th>Fecha Término</th>
                                                                                    <th>Acciones</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr v-for="evento in eventos" :key="evento.id">
                                                                                    <td>{{ Number(evento.digitalizados_revisados || 0) }}</td>
                                                                                    <td>{{ Number(evento.asistentes_crm || 0) }}</td>
                                                                                    <td>{{ Number(evento.total_evento || evento.cantidad_inscripciones || 0) }}</td>
                                                                                    <td>{{ evento.codigo }}</td>
                                                                                    <td>{{ formatearNombreEvento(evento) }}</td>
                                                                                    <td>{{ evento.estado_evento_label }}</td>
                                                                                    <td>{{ formatFechaHora(evento.fecha_inicio) }}</td>
                                                                                    <td>{{ formatFechaHora(evento.fecha_termino) }}</td>
                                                                                    <td>
                                                                                        <b-button size="sm" variant="primary" @click="ver_evento(evento)">Ver</b-button>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="text-muted py-2">No hay eventos asociados para este colegio.</div>
                                                            </b-tab>

                                                            <b-tab title="Evaluaciones" v-if="user.id==1">
                                                                <div v-if="evaluacionesActividad.length > 0" class="table-responsive">
                                                                    <table class="table table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Código Evento</th>
                                                                                <th>Nombre Evento</th>
                                                                                <th>Calificación</th>
                                                                                <th>Fecha Respuesta</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="evaluacion in evaluacionesActividad" :key="`${evaluacion.evento_id}-${evaluacion.respondida_en || 'sin-fecha'}-${evaluacion.codigo}`">
                                                                                <td>{{ evaluacion.codigo || '-' }}</td>
                                                                                <td>{{ evaluacion.nombre_difusion || '-' }}</td>
                                                                                <td>{{ formatearCalificacion(evaluacion.calificacion) }}</td>
                                                                                <td>{{ formatFechaHora(evaluacion.respondida_en) }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div v-else class="text-muted py-2">No hay evaluaciones de actividad para este colegio.</div>
                                                            </b-tab>

                                                            <b-tab title="Comentarios">
                                                                <div class="form-group">
                                                                    <label for="comentarioColegio">Nuevo comentario</label>
                                                                    <textarea
                                                                        id="comentarioColegio"
                                                                        v-model="comentarioNuevo"
                                                                        class="form-control"
                                                                        rows="4"
                                                                        maxlength="2000"
                                                                        placeholder="Escribe un comentario sobre el colegio"
                                                                    ></textarea>
                                                                    <small :class="comentarioCharsRestantes < 100 ? 'text-danger' : 'text-muted'">
                                                                        {{ comentarioCharsRestantes }} caracteres restantes
                                                                    </small>
                                                                </div>
                                                                <div class="mb-3">
                                                                    <b-button
                                                                        variant="primary"
                                                                        @click="guardarComentarioColegio"
                                                                        :disabled="guardandoComentario || comentarioCharsRestantes < 0 || !comentarioNuevo.trim()"
                                                                    >
                                                                        {{ guardandoComentario ? 'Guardando...' : 'Guardar comentario' }}
                                                                    </b-button>
                                                                </div>

                                                                <div class="form-group">
                                                                    <label for="busquedaComentario">Buscar en comentarios</label>
                                                                    <input
                                                                        id="busquedaComentario"
                                                                        v-model="busquedaComentario"
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Filtrar por texto, usuario o respuesta CRM"
                                                                    >
                                                                    <small class="text-muted">{{ comentariosFiltrados.length }} comentario(s) visibles</small>
                                                                </div>

                                                                <div v-if="comentariosColegio.length > 0" class="table-responsive">
                                                                    <table class="table table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Comentario</th>
                                                                                <th>Usuario</th>
                                                                                <th>Fecha comentario</th>
                                                                                <th>Fecha envío CRM</th>
                                                                                <th>Estado CRM</th>
                                                                                <th>Respuesta CRM</th>
                                                                                <th>Acción</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="comentario in comentariosFiltrados" :key="comentario.id">
                                                                                <td style="white-space: pre-wrap;">{{ comentario.comentario }}</td>
                                                                                <td>{{ comentario.usuario_nombre || '-' }}</td>
                                                                                <td>{{ formatFechaHora(comentario.created_at) }}</td>
                                                                                <td>{{ formatFechaHora(comentario.sync_enviado_at) }}</td>
                                                                                <td>
                                                                                    <span class="badge" :class="estadoSyncBadgeClass(comentario)">
                                                                                        {{ estadoSyncLabel(comentario) }}
                                                                                    </span>
                                                                                    <div class="small text-muted" v-if="comentario.sync_http_status">
                                                                                        HTTP {{ comentario.sync_http_status }}
                                                                                    </div>
                                                                                    <div class="small text-muted" v-if="comentario.sync_intentos !== null && comentario.sync_intentos !== undefined">
                                                                                        Intentos: {{ comentario.sync_intentos }}
                                                                                    </div>
                                                                                </td>
                                                                                <td style="white-space: pre-wrap; max-width: 360px;">{{ respuestaSyncTexto(comentario) }}</td>
                                                                                <td>
                                                                                    <b-button
                                                                                        size="sm"
                                                                                        variant="outline-primary"
                                                                                        @click="reenviarComentarioColegio(comentario)"
                                                                                        :disabled="!!reenviandoComentarios[comentario.id]"
                                                                                    >
                                                                                        {{ reenviandoComentarios[comentario.id] ? 'Reenviando...' : 'Reintentar envío' }}
                                                                                    </b-button>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div v-else class="text-muted py-2">Aún no hay comentarios para este colegio.</div>
                                                                <div v-if="comentariosColegio.length > 0 && comentariosFiltrados.length === 0" class="text-muted py-2">
                                                                    No hay coincidencias para la búsqueda actual.
                                                                </div>
                                                            </b-tab>
                                                        </b-tabs>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="ColegioNoExiste">
                                <div class="card mt-3 shadow-sm border-light">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <div class="card mt-3">
                                                    <div class="card-body">
                                                        <p>No se encontraron datos del colegio RBD {{ colegioseleccionada.rbd }}</p>
                                                        <b-button
                                                            class="mt-2 mr-2"
                                                            variant="success"
                                                            @click="actualizarDesdeAPIExterna"
                                                        >
                                                            Consultar CRM
                                                        </b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style>

.colegio-detail-card {
    border: 0;
    border-radius: 1rem;
    background: transparent;
    box-shadow: none;
}

.colegio-detail-card > .card-body {
    padding: 1rem;
}

.colegio-detail-hero {
    margin: 0 0 1.25rem;
    padding: 0;
    border-radius: 0.35rem;
    overflow: hidden;
}

.colegio-detail-hero-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 0.9rem 1rem;
    border-radius: 0.25rem;
    background: linear-gradient(90deg, #b86a2f 0%, #cf7e3a 55%, #e5a35f 100%);
    box-shadow: 0 16px 30px rgba(201, 126, 55, 0.22);
}

.colegio-detail-hero-bar__left {
    min-width: 0;
}

.colegio-detail-hero-bar__title-row {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    margin-bottom: 0.28rem;
}

.colegio-detail-hero-bar__icon {
    flex: 0 0 auto;
    color: #fff;
    font-size: 1.15rem;
}

.colegio-detail-hero-bar__title {
    min-width: 0;
    margin: 0;
    color: #fff;
    font-size: 1.6rem;
    line-height: 1.1;
    font-weight: 800;
    overflow-wrap: anywhere;
}

.colegio-detail-hero-bar__meta {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    flex-wrap: wrap;
    color: rgba(255, 255, 255, 0.92);
    font-size: 0.88rem;
    font-weight: 500;
}

.colegio-detail-chip {
    display: inline-flex;
    align-items: center;
    padding: 0.12rem 0.45rem;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.16);
    color: #fff;
    font-size: 0.74rem;
    font-weight: 800;
}

.colegio-detail-hero-bar__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.7rem;
    flex-wrap: wrap;
}

.colegio-detail-action-btn {
    min-height: 38px;
    padding: 0.58rem 0.9rem;
    border: 0;
    border-radius: 0.7rem;
    font-weight: 600;
    box-shadow: none !important;
}

.colegio-detail-action-btn--white {
    border: 1px solid rgba(111, 68, 35, 0.16) !important;
    background: #fff !important;
    color: #6f4423 !important;
}

.colegio-detail-action-btn--white:hover,
.colegio-detail-action-btn--white:focus {
    background: #fff7f0 !important;
    color: #8a542c !important;
}

.colegio-detail-action-btn--white i {
    color: inherit !important;
}

.colegio-detail-update {
    padding: 0.7rem 0.2rem 0;
    color: #7b8494;
    font-size: 0.84rem;
}

.colegio-detail-update strong {
    color: #4f5b6b;
    font-weight: 700;
}

.colegio-detail-readonly {
    align-items: stretch;
}

.colegio-detail-column {
    display: flex;
    margin-bottom: 1rem;
}

.colegio-detail-panel {
    width: 100%;
    height: 100%;
    padding: 0;
    border: 1px solid #e9ecef;
    border-radius: 1rem;
    background: #fff;
    box-shadow: 0 12px 28px rgba(33, 37, 41, 0.05);
    overflow: hidden;
}

.colegio-detail-panel__title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.9rem 1rem;
    background: #f8f9fa;
    color: #31384c;
    font-size: 0.92rem;
    font-weight: 800;
    letter-spacing: 0.01em;
}

.colegio-detail-panel__title::before {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background: #cb9700;
    content: '';
}

.colegio-detail-table {
    display: table;
    width: 100%;
}

.colegio-detail-table__row {
    display: table-row;
}

.colegio-detail-table__label,
.colegio-detail-table__value {
    display: table-cell;
    padding: 0.72rem 1rem;
    border-bottom: 1px dashed #e5e7eb;
    line-height: 1.45;
    vertical-align: top;
}

.colegio-detail-table__label {
    width: 38%;
    color: #31384c;
    font-weight: 800;
}

.colegio-detail-table__value {
    color: #596270;
    overflow-wrap: anywhere;
}

.colegio-detail-table__value--wrap {
    word-break: break-word;
}

.colegio-detail-table__row:last-child .colegio-detail-table__label,
.colegio-detail-table__row:last-child .colegio-detail-table__value {
    border-bottom: 0;
}

.colegio-detail-tabs-wrap {
    margin-top: 0.5rem;
}

.colegio-detail-tabs .nav-tabs {
    gap: 0.25rem;
    border-bottom: 1px solid #d7dce6;
}

.colegio-detail-tabs .nav-tabs .nav-link {
    padding: 0.7rem 1rem;
    border: 1px solid transparent;
    border-top-left-radius: 0.65rem;
    border-top-right-radius: 0.65rem;
    color: #5e6470;
    font-weight: 400;
}

.colegio-detail-tabs .nav-tabs .nav-link.active {
    border-color: #d7dce6 #d7dce6 #fff;
    background: #fff;
    color: #31384c;
    box-shadow: 0 -2px 0 0 #cb9700 inset;
}

@media (max-width: 767px) {
    .colegio-detail-card > .card-body {
        padding: 0.75rem;
    }

    .colegio-detail-hero-bar {
        align-items: stretch;
        flex-direction: column;
        padding: 1rem;
    }

    .colegio-detail-hero-bar__title {
        font-size: 1.3rem;
    }

    .colegio-detail-hero-bar__actions {
        width: 100%;
    }

    .colegio-detail-hero-bar__actions .btn {
        width: 100%;
    }

    .colegio-detail-table,
    .colegio-detail-table__row,
    .colegio-detail-table__label,
    .colegio-detail-table__value {
        display: block;
        width: 100%;
    }

    .colegio-detail-table__label {
        padding-bottom: 0.2rem;
        border-bottom: 0;
    }

    .colegio-detail-table__value {
        padding-top: 0;
    }

    .colegio-detail-tabs .nav-tabs {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
    }
}

.card-buscador-colegios,
.card-buscador-colegios-body,
.row-buscador-colegios,
.contenedor-buscador-colegios {
    overflow: visible !important;
}

.multiselect-buscador-colegios {
    position: relative;
    z-index: 50;
}

.multiselect-buscador-colegios .multiselect__content-wrapper {
    max-height: 420px !important;
    overflow-y: auto !important;
    z-index: 60 !important;
}

.card-espaciador-buscador-colegios {
    min-height: 420px;
    background: #fff;
    border: 0;
    box-shadow: none;
}

@media (max-width: 768px) {
    .multiselect-buscador-colegios .multiselect__content-wrapper {
        max-height: 320px !important;
    }

    .card-espaciador-buscador-colegios {
        min-height: 320px;
    }
}
</style>
